import { styled } from 'theme'

export const StyledPage = styled.div`
  .page-content {
    background-color: white;
    padding: 24px;
  }
`
